import { useContext } from "react";
import { HtmlEditorContext } from "./editor.context";

export const useHtmlEditorContext = () => {
  return useContext(HtmlEditorContext);
};
